// extracted by mini-css-extract-plugin
module.exports = {"bottomfooter":"style__bottomfooter__f9f+m","images":"style__images__s2VyA","wrapper":"style__wrapper__K1GSD"};